<template>
  <div class="process">
    <div class="nav-process-movil">
      <ul data-v-step="14" id="style-1">
        <li
          v-for="(item, index) in getProcessSelected.SubProcess"
          :key="index"
          :data-v-step="10 + index"
        >
          <div
            class="item"
            :class="item.name === getSubProcessSelected.name ? 'selected' : ''"
            @click="toggleNav(item.name)"
          >
            {{ item.name }}
          </div>
        </li>
      </ul>
    </div>
    <div class="cnPro-header">
      <h2>{{ getProcessSelected.name }}</h2>
    </div>
    <div class="content-process" style="position: relative">
      <DinamicRenderSubProcessVue v-if="getSubProcessSelected !== undefined" />
      <FormToUploadInnputsVue v-if="getSubProcessSelected.name === 'Inputs'" />
      <TableInputsVue v-if="getSubProcessSelected.name === 'Inputs'" />
      <TableReportsVue v-if="getSubProcessSelected.name === 'Deliverables'" />
      <ConsultantsVue
        :Consultores="getConsultants(0)"
        v-if="getSubProcessSelected.name === 'Interaction'"
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";
import ConsultantsVue from "../Consultants2.vue";
import DinamicRenderSubProcessVue from "./DinamicRenderSubProcess.vue";
import FormToUploadInnputsVue from "./FormToUploadInnputs.vue";
import TableInputsVue from "./TableInputs.vue";
import TableReportsVue from "./TableReports.vue";
export default {
  components: {
    ConsultantsVue,
    TableReportsVue,
    DinamicRenderSubProcessVue,
    TableInputsVue,
    FormToUploadInnputsVue,
  },
  computed: {
    ...mapGetters([
      "getProcessSelected",
      "getSubProcessSelected",
      "getConsultants",
    ]),
  },
  watch: {
    getProcessSelected(NewProcess) {
      this.setSubProcessSelected(NewProcess.SubProcess[0].name);
    },
  },
  methods: {
    ...mapMutations(["setSubProcessSelected"]),
    toggleNav(newPath) {
      this.setSubProcessSelected(newPath);
    },
    getArraysIntersection(a1, a2) {
      return a1.filter(function (n) {
        console.log(a2.indexOf(n.name) !== -1);
        return a2.indexOf(n.name) !== -1;
      });
    },
  },
};
</script>

<style>
.process {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 10px;
  box-shadow: 0px 10px 30px 0px rgba(0, 0, 0, 0.302);
}
.cnPro-header {
  width: 100%;
  text-align: center;
}
.cnPro-header h2 {
  display: inline-block;
  margin: 5px 0;
  font-family: "Montserrat", sans-serif;
  font-weight: 400;
  font-size: 1.8rem;
  border-bottom: 1px solid var(--firts-color);
}
.content-process {
  width: 80%;
  margin: 10px auto;
}

.process .nav-process-movil {
  display: block;
  width: 100%;
  padding: 10px;
  border-bottom: 1px solid var(--eighth-color);
}
.process .nav-process-movil ul {
  list-style-type: none;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow-x: auto;
  padding: 10px 0;
}
.process .nav-process-movil ul li .item {
  font-family: "Poppins", sans-serif;
  font-weight: 400;
  width: 200px;
  height: 35px;
  margin: 0 15px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: var(--third-color);
  border-radius: 10px;
  cursor: pointer;
}
.process .nav-process-movil ul li .item.selected {
  background: var(--sixth-color);
  font-weight: bold;
}

/*=============================================
ESCRITORIO PEQUEÑO O TABLET VERTICAL (SM revisamos en 768px)
=============================================*/

@media (max-width: 991px) and (min-width: 768px) {
  .process {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 0;
    box-shadow: none;
  }
  .process .nav-process-movil ul {
    justify-content: space-between;
  }

  .content-process {
    width: 100%;
    padding: 0;
  }
}
/*=============================================
MOVIL (XS revisamos en 320px)
=============================================*/

@media (max-width: 767px) {
  .process {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-radius: 0;
    box-shadow: none;
  }

  .process .nav-process-movil {
    display: block;
    width: 100%;
  }
  .process .nav-process-movil ul {
    list-style-type: none;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  .process .nav-process-movil ul li .item {
    font-family: "Poppins", sans-serif;
    font-weight: 400;
    width: 200px;
    height: 35px;
    margin: 0 15px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--third-color);
    border-radius: 10px;
  }
  .process .nav-process-movil ul li .item.selected {
    background: var(--sixth-color);
    font-weight: bold;
  }
  .content-process {
    width: 100%;
    padding: 0;
  }
}
</style>